import React from 'react';
import { T, font, mono, STATUS } from '../utils/theme';
import { Card, Sect } from './UI';

export default function AdminDashboard({ lang, products, suppliers, allSuppliers, activity, shipments, Lk }) {
  // The rows the Quoting screen lists: a suggested version still waiting on us is reviewed inside its
  // item there, not as a row of its own, so it is not counted here either.
  const quotingP = products.filter(p => p.status === 'quoting' && !(p.variant_state === 'provisional' && p.restrict_supplier));
  const assignedP = products.filter(p => p.status === 'supplier_assigned');
  const orderingP = products.filter(p => p.status === 'ordering');
  const onTheWayP = products.filter(p => p.status === 'on_the_way');
  const inStockP = products.filter(p => p.in_stock);

  const actColors = {
    confirmed: T.purple, newQuotes: STATUS.quoting.color, newAssigned: STATUS.supplier_assigned.color,
    shipped: T.success, price_change: T.warn, shipment_deleted: T.danger, password_revealed: T.warn,
    variantProposed: T.warn, variantOpened: T.success, variantRejected: T.dim, supplierNote: T.accent,
    discontinued: T.dim, reenabled: T.success,
  };
  const actIcons = { confirmed: '✓', newQuotes: '★', newAssigned: '⚡', shipped: '📦', price_change: '✎', shipment_deleted: '🗑', password_revealed: '🔑',
    variantProposed: '＋', variantOpened: '📢', variantRejected: '—', supplierNote: '💬', discontinued: '⊘', reenabled: '↺' };
  const actLabels = { variantProposed: lang === 'zh' ? '已提交版本' : 'Version suggested', variantOpened: lang === 'zh' ? '版本已开放' : 'Version opened to all',
    variantRejected: lang === 'zh' ? '版本未采用' : 'Version not needed', supplierNote: lang === 'zh' ? '供应商备注' : 'Supplier note',
    discontinued: lang === 'zh' ? '已停用' : 'Disabled', reenabled: lang === 'zh' ? '已启用' : 'Enabled again' };

  return (
    <div>
      <h2 style={{ margin: '0 0 22px', fontSize: 22, fontWeight: 900, color: T.text }}>{Lk('dashboard')}</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12, marginBottom: 28 }}>
        {[
          { v: suppliers.length, l: Lk('suppliers'), c: T.accent },
          { v: quotingP.length, l: Lk('quoting'), c: T.warn },
          { v: assignedP.length + orderingP.length, l: Lk('ordering'), c: T.purple },
          { v: onTheWayP.length, l: Lk('onTheWay'), c: T.accent },
          { v: inStockP.length, l: Lk('inStock'), c: T.success },
        ].map((s, i) => (
          <Card key={i}>
            <div style={{ fontSize: 28, fontWeight: 900, color: s.c, lineHeight: 1 }}>{s.v}</div>
            <div style={{ fontSize: 11, color: T.muted, fontWeight: 700, marginTop: 5, textTransform: 'uppercase' }}>{s.l}</div>
          </Card>
        ))}
      </div>

      <Sect title={Lk('recentActivity')}>
        {activity.length === 0 ? (
          <div style={{ color: T.dim, fontSize: 13, fontStyle: 'italic' }}>{Lk('noActivity')}</div>
        ) : (
          activity.slice(0, 15).map(a => {
            const sup = allSuppliers?.find(s => s.id === a.supplier_id);
            return (
            <div key={a.id} style={{
              display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', marginBottom: 4,
              background: T.surface, borderRadius: 8, border: `1px solid ${T.border}`,
              borderLeft: `3px solid ${actColors[a.type] || T.dim}`,
            }}>
              <span style={{ fontSize: 16, width: 24, textAlign: 'center' }}>{actIcons[a.type] || '•'}</span>
              <div style={{ flex: 1 }}>
                <span style={{ color: actColors[a.type] || T.text, fontWeight: 700, fontSize: 13 }}>{actLabels[a.type] || a.type}</span>
                <span style={{ color: T.muted, marginLeft: 8, fontSize: 13 }}>— {a.product_name || a.actor}</span>
                {sup && <span style={{ color: T.accent, marginLeft: 8, fontSize: 11, fontWeight: 600 }}>({sup.name})</span>}
              </div>
              <span style={{ fontSize: 11, color: T.dim, fontFamily: mono }}>{a.date} {a.time}</span>
            </div>
          );})
        )}
      </Sect>
    </div>
  );
}
